import { DashboardConstants } from '../../actions/constant';

const {
  GET_TODAY_PATIENT_LIST_FAILURE,
  GET_TODAY_PATIENT_LIST_LOADER,
  GET_TODAY_PATIENT_LIST_SUCCESS,
  GET_TODAY_PATIENT_LIST_RESET,
} = DashboardConstants;

const initialState: object = {
  response: null,
  isError: false,
  loading: false,
};

export const getTodayPatientListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_TODAY_PATIENT_LIST_SUCCESS:
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };

    case GET_TODAY_PATIENT_LIST_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_TODAY_PATIENT_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };

    case GET_TODAY_PATIENT_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};
